import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import ServiceCentersResultsComponent from "@/pages/serviceCenters/ServiceCentersComponents/ServiceCentersFiltersComponents/ServiceCentersFiltersComponent";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useLocation, useSearchParams } from "react-router-dom";
import useHelpers from "@hooks/useHelpers";
import useButtonLoading from "@hooks/useButtonLoading";
import useFullLoading from "@hooks/useFullLoading";
import { api__getAvailableSCData, api__getServiceCentersResults } from "@/apis/cars-service-centers/cars-services-centers";
import useApi from "@/common/hooks/useApi";
var ServiceCentersFilters = function ServiceCentersFilters() {
  var location = useLocation();
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useState = useState({}),
    availableSCData = _useState[0],
    setAvailableSCData = _useState[1];
  //------------------------------------------------------------------
  var resultsLoading = useButtonLoading();
  var loading = useFullLoading();
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 2),
    searchParams = _useSearchParams2[0],
    setSearchParams = _useSearchParams2[1];
  //------------------------------------------------------------------
  var _useState2 = useState(false),
    showPopUp = _useState2[0],
    setShowPopUp = _useState2[1];
  var _useState3 = useState({
      make_id: {
        name: "",
        value: searchParams.get("make_id") ? searchParams.get("make_id") : ""
      },
      city_id: {
        name: "",
        value: searchParams.get("city_id") ? searchParams.get("city_id") : ""
      },
      dealership_name: {
        name: searchParams.get("dealership_name") ? searchParams.get("dealership_name") : "",
        value: searchParams.get("dealership_name") ? searchParams.get("dealership_name") : ""
      }
    }),
    filters = _useState3[0],
    setFilters = _useState3[1];

  // Using useApi hook to fetch service centers results
  var _useApi = useApi([filters.make_id.value, filters.city_id.value, filters.dealership_name.value, location.search], function () {
      return api__getServiceCentersResults(filters);
    }),
    _useApi2 = _slicedToArray(_useApi, 3),
    isLoading = _useApi2[0],
    error = _useApi2[1],
    availableSCResults = _useApi2[2];
  var _useState4 = useState({
      name: "",
      key: "",
      title: "",
      label: "",
      popUpTitle: "",
      minLengthForSearch: 1,
      selectedValue: [],
      data: [],
      getData: function getData() {}
    }),
    popUpData = _useState4[0],
    setPopUpData = _useState4[1];
  //------------------------------------------------------------------
  var handleFiltersChange = function handleFiltersChange(fieldName, name, key) {
    if (filters[fieldName].name === name) return;
    var newFields = _objectSpread({}, filters);
    newFields[fieldName] = {
      name: name,
      value: key
    };
    if (fieldName === "make_id") {
      newFields["city_id"] = {
        name: "",
        value: ""
      };
      newFields["dealership_name"] = {
        name: "",
        value: ""
      };
      searchParams.set("city_id", "");
      searchParams.set("dealership_name", "");
    }
    if (fieldName === "city_id") {
      newFields["dealership_name"] = {
        name: "",
        value: ""
      };
      searchParams.set("dealership_name", "");
    }
    searchParams.set(fieldName, key);
    setSearchParams(searchParams);
    setFilters(newFields);
    api__getAvailableSCData(Object.entries(newFields).map(function (item) {
      return "".concat(item[0], "=").concat(item[1].value);
    })).then(setAvailableSCData);
  };
  //------------------------------------------------------------------
  var handleSingleFilterChange = function handleSingleFilterChange(key, title, label, popUpTitle, selectedValue, data, getData) {
    // if (!selectedValue) return;
    setPopUpData(function () {
      return {
        name: key,
        key: key,
        title: title,
        label: label,
        popUpTitle: popUpTitle,
        selectedValue: selectedValue,
        data: data,
        getData: getData
      };
    });
  };
  //------------------------------------------------------------------

  // The useEffect with getSCResults is removed as we're using useApi hook now

  useEffect(function () {
    if (!searchParams.get("make_id")) {
      document.location = createUrl("/service-centers");
    }
    if (!Object.keys(availableSCData).length) {
      api__getAvailableSCData(Object.entries(filters).map(function (item) {
        return "".concat(item[0], "=").concat(item[1].value);
      })).then(setAvailableSCData);
    }
  }, []);
  useEffect(function () {
    if (Object.keys(availableSCData).length) {
      setFilters(function (preValues) {
        var _availableSCData$make, _availableSCData$make2, _availableSCData$citi, _availableSCData$citi2, _availableSCData$citi3, _availableSCData$citi4, _availableSCData$waka, _availableSCData$waka2, _availableSCData$waka3, _availableSCData$waka4;
        return _objectSpread(_objectSpread({}, preValues), {}, {
          make_id: _objectSpread(_objectSpread({}, preValues["make_id"]), {}, {
            name: availableSCData === null || availableSCData === void 0 ? void 0 : (_availableSCData$make = availableSCData.makes) === null || _availableSCData$make === void 0 ? void 0 : (_availableSCData$make2 = _availableSCData$make.find(function (make) {
              return parseInt(make.id) === parseInt(searchParams.get("make_id"));
            })) === null || _availableSCData$make2 === void 0 ? void 0 : _availableSCData$make2.name
          }),
          city_id: _objectSpread(_objectSpread({}, preValues["city_id"]), {}, {
            name: availableSCData !== null && availableSCData !== void 0 && (_availableSCData$citi = availableSCData.cities) !== null && _availableSCData$citi !== void 0 && (_availableSCData$citi2 = _availableSCData$citi.find(function (city) {
              return parseInt(city.id) === parseInt(searchParams.get("city_id"));
            })) !== null && _availableSCData$citi2 !== void 0 && _availableSCData$citi2.name ? availableSCData === null || availableSCData === void 0 ? void 0 : (_availableSCData$citi3 = availableSCData.cities) === null || _availableSCData$citi3 === void 0 ? void 0 : (_availableSCData$citi4 = _availableSCData$citi3.find(function (city) {
              return parseInt(city.id) === parseInt(searchParams.get("city_id"));
            })) === null || _availableSCData$citi4 === void 0 ? void 0 : _availableSCData$citi4.name : ""
          }),
          dealership_name: _objectSpread(_objectSpread({}, preValues["dealership_name"]), {}, {
            name: availableSCData !== null && availableSCData !== void 0 && (_availableSCData$waka = availableSCData.wakalat) !== null && _availableSCData$waka !== void 0 && (_availableSCData$waka2 = _availableSCData$waka.find(function (wakaleh) {
              return parseInt(wakaleh.id) === parseInt(searchParams.get("dealership_name"));
            })) !== null && _availableSCData$waka2 !== void 0 && _availableSCData$waka2.name ? availableSCData === null || availableSCData === void 0 ? void 0 : (_availableSCData$waka3 = availableSCData.wakalat) === null || _availableSCData$waka3 === void 0 ? void 0 : (_availableSCData$waka4 = _availableSCData$waka3.find(function (wakaleh) {
              return parseInt(wakaleh.id) === parseInt(searchParams.get("dealership_name"));
            })) === null || _availableSCData$waka4 === void 0 ? void 0 : _availableSCData$waka4.name : ""
          })
        });
      });
    }
  }, [availableSCData]);
  //------------------------------------------------------------------
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout, {
    hasNavBar: true,
    authenticationMsg: true,
    mainClass: "",
    linksForSearch: true,
    hideOrangeHeadBtn: true,
    hideAppBanner: true,
    hideFooterWithoutAuthMsg: true,
    mobileHasBack: true,
    disableLoader: true
  }, /*#__PURE__*/React.createElement(ServiceCentersResultsComponent, {
    filters: filters,
    availableSCData: availableSCData,
    availableSCResults: availableSCResults || [],
    onFiltersChange: handleFiltersChange,
    popUpData: popUpData,
    setPopUpData: setPopUpData,
    showPopUp: showPopUp,
    setShowPopUp: setShowPopUp,
    onSingleFilterChange: handleSingleFilterChange,
    resultsLoading: isLoading || resultsLoading,
    loading: loading
  })));
};
export default ServiceCentersFilters;